var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import appConfigJSON from './appConfig.json';
/**
 * Configuration class to load JSON file, provide access to the values in that file. i.e.
 *
 *  {
 * 		"main": { // environment this is default
 * 			"basekey": "Something Unique here", // Access via AppConfig.get("basekey")
 * 			"splitkey": { // Can access this value directly. Will return JSON values defined.
 * 				"key1": "Some value", // Access via AppConfig.get("splitkey/key1") accessor.
 * 				"key2": "Some Value"
 * 			}
 * 		}
 * 	}
 *
 */

var AppConfig = function () {

	/**
  *
  * @param {*} namespace
  */
	function AppConfig() {
		var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'main';

		_classCallCheck(this, AppConfig);

		this.namespace = namespace;
		this.data = appConfigJSON;

		//Check if namespace exists in loaded JSON file.
		if (typeof this.data[this.namespace] == 'undefined') {
			throw 'AppConfig namespace \'' + this.namespace + '\' not defined.';
		}

		//Define the base array if namespace exists in loaded JSON file.
		this.base = this.data[this.namespace];
	}

	_createClass(AppConfig, [{
		key: 'get',
		value: function get(key) {
			return this.getPath(key);
		}
	}, {
		key: 'test',
		value: function test() {
			return 'test';
		}

		/**
   * Detect if the key is a path and split.
   * @param {*} key
   */

	}, {
		key: 'getPath',
		value: function getPath(key) {
			var chunks = key.split("/");

			if (chunks.length > 1) {
				var segment = this.base;
				chunks.forEach(function (chunk) {
					if (typeof segment[chunk] == 'undefined') {
						throw 'Segment of AppConfig "' + chunk + '" path not found.';
					} else {
						segment = segment[chunk];
					}
				});
				return segment;
			} else {
				if (typeof this.base[key] == 'undefined') {
					throw 'AppConfig::Get ' + key + ' undefined.';
				}
				return this.base[key];
			}
		}
	}]);

	return AppConfig;
}();

export default AppConfig;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/config/AppConfig.js
// module id = 108
// module chunks = 0